import React, { Component } from "react";
import Axios from "axios";

import {API_BASE_URL, API_KEY, LANGUAGE, MOVIE_POSTER_URL} from "../../services/const";
import './filmes.css';
import CoversRow from '../novidades/CoversRow';
import Modal from '../sitestruct/modal/Modal';
import MovieDetails from "../sitestruct/movieDetails/MovieDetails";


export default class Filmes extends Component {

    /**
     * Class constructor
     */
    constructor() {
        super();

        //schedules an update to a component state object. When state changes, the component responds rendering itself
        this.state = {
            genres: [],              //array to store movies genres (categories)
            films: [],               //array to store detais from movie
            modalShow: false,        //"boolean" variable to control if we want to show/hide the details modal
            showDetailPage: false,   //"boolean" variable to control if we want to show/hide the details page
            selectedDetailMovie:{}   //selected movie data
        };

        this.onclickmovie = this.onclickmovie.bind(this);             //Image click action. Open movie dedtailf from movie ID
        this.onclickback = this.onclickback.bind(this);               //Allow to user go back to previous page
        this.getOptionSelected = this.getOptionSelected.bind(this);   //to select an option from dropdown

    }


    /**
     * This method runs after the component output has been rendered to the DOM.
     */
    componentDidMount() {
        let categoriesApi = `${API_BASE_URL}/genre/movie/list?api_key=${API_KEY}&language=${LANGUAGE}`;  //url request to API

        Axios.get(categoriesApi)                  //from url, get data
            .then(({ data }) => {
                const { genres } = data;          //save on genres variable content of data (from API)

                this.setState({ genres } ); //change the components state
            });
    }



    /**
     * This method open the details page of selected movie
     *
     * @param id: Movie ID
     */
    onclickmovie(id){
        var movie = this.state.films.find(x => parseInt(x.key) === id);  //get movie ID and compare with selected movie ID

        //change the components state
        this.setState({
            showDetailPage: true,       //set the boolean var to true to open the details page
            selectedDetailMovie: movie  //If want open details page, this var (movie) carries all information about selected movie
        });
    }


    /**
     * This method allow to user go to previous page
     */
    onclickback(){
        this.setState({
            showDetailPage: false   //set the boolean var to false to close the details page
        });
    }



    /**
     * This method get the value of selected option from dropdown
     */
    getOptionSelected(e) {
        let categoriesApi = API_BASE_URL + '/search/multi?api_key=' + API_KEY + '&query=' + e.target.value + '&language=' + LANGUAGE + '&page=1';  //url request to API

        Axios.get(categoriesApi)
            .then( ({ data }) => {
                const results = data.results;    //get all raw results and store on var results
                var coverRows = [];              //this var coverRows is an array to store all movie covers

                results.forEach( (movie) => {                                                                  //for each results do:
                    movie.poster_src = MOVIE_POSTER_URL + movie.poster_path;                                       //get the image url from API and append to another url to show image
                    const movieRow = <CoversRow key={movie.id} movie={movie} onclickcover={this.onclickmovie} />   //"send" to component CoversRow all covers with on click event

                    coverRows.push(movieRow);                                                                      //store on array, all movie covers
                });

                this.setState({ films: coverRows }); //element (rows) for the "render"
            });
    }


    /**
     * This method render the information (data from previous functions) with HTML code
     * @returns Return page information inside HTML
     */
    render() {
        const { genres } = this.state;

        if(this.state.showDetailPage){
            return (<MovieDetails movieobj={this.state.selectedDetailMovie}     /* this state have all information about selected movie */
                                  onclickbacktofilms={this.onclickback}         /* image click event: call the function onclickback from component MovieDetails */
            />);
        }else{
            return (
                <div>
                    <h1>Página Filmes</h1>
                    <p>Seleccione uma categoria que deseja, seleccione um filme do seu agrado e desfrute!</p>
                    <select className="form-control mt-4 col-md-2 col-offset-4" id="categorySelectBox" onChange={this.getOptionSelected}>
                        {genres.map( ({ id, name }) => (
                            <option key={id} id={id} value={name}> {name} </option>
                        ))}
                    </select>

                    <hr/>
                    <div className="row">
                        {this.state.films}
                    </div>

                    {/*<Modal show={this.state.modalShow}/>*/} {/*Show modal with selected movie*/}
                    {/* <MovieDetails show={this.state.movieDetailShow} /> */}
                </div>
            );
        }
    }
}
